/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CashflowForecastIndicatorDistributionEntry'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CashflowForecastIndicatorDistributionEntry'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CashflowForecastIndicatorDistributionEntryApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CashflowForecastIndicatorDistributionEntry);
  }
}(this, function(ApiClient, CashflowForecastIndicatorDistributionEntry) {
  'use strict';

  /**
   * CashflowForecastIndicatorDistributionEntry service.
   * @module api/CashflowForecastIndicatorDistributionEntryApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new CashflowForecastIndicatorDistributionEntryApi. 
   * @alias module:api/CashflowForecastIndicatorDistributionEntryApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the cashflowForecastIndicatorDistributionEntryAddAllPut operation.
     * @callback module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/CashflowForecastIndicatorDistributionEntry>} body 
     * @param {module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.cashflowForecastIndicatorDistributionEntryAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorDistributionEntryAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorDistributionEntryAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorDistributionEntry/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorDistributionEntryAddPut operation.
     * @callback module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/CashflowForecastIndicatorDistributionEntry} body 
     * @param {module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.cashflowForecastIndicatorDistributionEntryAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorDistributionEntryAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorDistributionEntryAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorDistributionEntry/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorDistributionEntryDeleteAllPut operation.
     * @callback module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastIndicatorDistributionEntryDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorDistributionEntryDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorDistributionEntryDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorDistributionEntry/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorDistributionEntryDeleteGet operation.
     * @callback module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} distributionID 
     * @param {module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastIndicatorDistributionEntryDeleteGet = function(_4SAPIAppID, distributionID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorDistributionEntryDeleteGet";
      }

      // verify the required parameter 'distributionID' is set
      if (distributionID == undefined || distributionID == null) {
        throw "Missing the required parameter 'distributionID' when calling cashflowForecastIndicatorDistributionEntryDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'distributionID': distributionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorDistributionEntry/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorDistributionEntryEditAllPut operation.
     * @callback module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/CashflowForecastIndicatorDistributionEntry>} body 
     * @param {module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastIndicatorDistributionEntryEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorDistributionEntryEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorDistributionEntryEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorDistributionEntry/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorDistributionEntryEditPut operation.
     * @callback module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/CashflowForecastIndicatorDistributionEntry} body 
     * @param {module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntryEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.cashflowForecastIndicatorDistributionEntryEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorDistributionEntryEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorDistributionEntryEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorDistributionEntry/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cashflowForecastIndicatorDistributionEntrySearchPut operation.
     * @callback module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntrySearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/CashflowForecastIndicatorDistributionEntry>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {module:model/CashflowForecastIndicatorDistributionEntry} body 
     * @param {module:api/CashflowForecastIndicatorDistributionEntryApi~cashflowForecastIndicatorDistributionEntrySearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/CashflowForecastIndicatorDistributionEntry>}
     */
    this.cashflowForecastIndicatorDistributionEntrySearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling cashflowForecastIndicatorDistributionEntrySearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cashflowForecastIndicatorDistributionEntrySearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [CashflowForecastIndicatorDistributionEntry];

      return this.apiClient.callApi(
        '/CashflowForecastIndicatorDistributionEntry/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
